"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbiRegistry = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _fastDeepEqual = _interopRequireDefault(require("fast-deep-equal"));
var _remeda = require("remeda");
var _standardAbis = _interopRequireDefault(require("./standard-abis"));
class AbiRegistry {
  constructor() {
    (0, _defineProperty2.default)(this, "map", new Map());
    this.addAll(_standardAbis.default);
  }
  get(key) {
    return this.map.get(key);
  }
  addAll(abis) {
    for (let [key, abi] of Object.entries(abis)) {
      this.set(key, abi);
    }
  }
  add(abi) {
    let key = abi.name;
    let suffix = 2;
    while (this.map.has(key)) {
      // Normalize the ABIs first
      let existing = deserialize(serialize(this.get(key)));
      let normalized = deserialize(serialize(abi));
      if ((0, _fastDeepEqual.default)(existing, normalized)) {
        // If they're equal, just use that key
        return key;
      }
      key = abi.name + suffix;
      ++suffix;
    }
    this.set(key, abi);
    return key;
  }
  set(key, value) {
    let val = (0, _remeda.clone)(value);
    if (!val.type) {
      val.type = "function";
      val.stateMutability = "view";
    }
    this.map.set(key, Object.freeze(val));
    return this;
  }
  toJSON() {
    let json = {};
    for (let [key, val] of this.map.entries()) {
      if (val.type === "function" && val.stateMutability === "view") {
        val = (0, _remeda.omit)(val, ["type", "stateMutability"]);
      }
      json[key] = val;
    }
    return json;
  }
}
exports.AbiRegistry = AbiRegistry;
function serialize(element) {
  if (!element.stateMutability) {
    if (element.constant === false) {
      if (element.payable) {
        element.stateMutability = 'payable';
      } else {
        element.stateMutability = 'nonpayable';
      }
    } else {
      element.stateMutability = "view";
    }
  }
  if (!element.type) {
    element.type = "function";
  }
  return JSON.stringify(element, (key, value) => {
    if (value.type) {
      let data = (0, _remeda.pick)(value, ['name', 'type', 'indexed', 'anonymous', 'stateMutability', 'inputs', 'outputs', 'components']);
      if (data.name === "") {
        delete data.name;
      }
      return data;
    }
    return value;
  });
}
function deserialize(data) {
  let fragment = JSON.parse(data);
  return fragment;
}
//# sourceMappingURL=AbiRegistry.js.map